module.exports = __webpack_public_path__ + "img/logo-AI-kasa.289c50b8.svg";